import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadiation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.1439 2.80273C20.0524 4.55156 22 7.73511 22 11.376H16C16 9.91967 15.2181 8.64957 14.0547 7.95003L17.1439 2.80127M2 11.376C4.34369 11.3792 5.6574 11.3805 8 11.376C8 9.92039 8.77755 8.64635 9.93996 7.94659L6.85455 2.80298C3.94706 4.55203 2 7.73583 2 11.376ZM13 11.376C13 11.9283 12.5523 12.376 12 12.376C11.4477 12.376 11 11.9283 11 11.376C11 10.8238 11.4477 10.376 12 10.376C12.5523 10.376 13 10.8238 13 11.376ZM17.1452 19.9526C15.642 20.8563 13.8817 21.376 12 21.376C10.1186 21.376 8.35853 20.8564 6.85547 19.9529L9.94056 14.8107C10.5418 15.172 11.2466 15.376 11.9991 15.376C12.7529 15.376 13.4579 15.1675 14.0597 14.8051L17.1452 19.9526Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRadiation;
